import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { CostsTable } from '../components/additional-costs/CostsTable';
import { CostsMobile } from '../components/additional-costs/CostsMobile';
export function AdditionalCosts() {
  return <>
      <section className="bg-brand-black px-4 pb-20 pt-10 text-center sm:px-6 lg:px-8 lg:pb-24 lg:pt-12" data-id="element-1154" data-mp="3l9itgywhq21p">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-4xl" data-id="element-1155" data-mp="36c06a0zgnwwd">
          <a href="#/pricing" className="inline-flex items-center gap-1.5 rounded-sm text-sm font-medium text-brand-light transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-1156" data-mp="2xcv66q893vi3">
            <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-1157" data-mp="10k32a2td0bbj" />
            Back to Pricing
          </a>
          <h1 className="mt-8 text-5xl font-extrabold leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl" data-id="element-1158" data-mp="19cht0e9gbok4">
            Every Additional Cost,
            <span className="block text-brand-red" data-id="element-1159" data-mp="159v3ik096fq3">Out In The Open</span>
          </h1>
          <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-gray-300 sm:text-xl" data-id="element-1160" data-mp="1j56xuqahy46h">
            No surprise bills. Here’s exactly what usage costs on each package — and why bigger packages get better rates.
          </p>
        </motion.div>
      </section>

      <section aria-label="Additional costs by package" className="bg-white px-4 py-16 sm:px-6 lg:px-8 lg:py-20" data-id="element-1161" data-mp="me4zysco9ba3">
        <CostsTable data-id="element-1162" data-mp="10dwagj3zc9jc" />
        <CostsMobile data-id="element-1163" data-mp="10a8i3na9tt67" />
      </section>

      <section className="bg-brand-black px-4 py-16 sm:px-6 lg:px-8" data-id="element-1164" data-mp="vd8k7znkrwq6">
        <div className="mx-auto flex max-w-5xl flex-col items-start gap-6 md:flex-row md:items-center md:justify-between" data-id="element-1165" data-mp="2brrotpn28e9i">
          <p className="max-w-2xl text-lg leading-relaxed text-brand-light" data-id="element-1166" data-mp="26tggxkgbsdtx">
            <span className="font-bold text-white" data-id="element-1167" data-mp="2etmrr1p27pne">Paying by ACH or check?</span> Prices shown are card prices. Email{' '}
            <a href="mailto:results@getadroi.com" className="font-semibold text-white underline underline-offset-2 hover:text-brand-light" data-id="element-1168" data-mp="2iu6mxzq2oj6w">
              results@getadroi.com
            </a>{' '}
            for ACH and check pricing.
          </p>
          <a href="#/contact" className="flex-shrink-0 whitespace-nowrap rounded-md bg-brand-red px-6 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors duration-150 ease-out hover:bg-brand-red-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-1169" data-mp="1v5vsbeayzfr2">
            CONTACT US
          </a>
        </div>
      </section>
    </>;
}